import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Утилита служит для предустановки значений по-умолчанию для всех полей на текущем шаге формы.
 * Если в `formValues` для поля не было указано значение, то ему будет присвоено undefined.
 *
 * Цель: у всех полей на шаге должно быть указано какое-то значение, чтобы Formik знал о них и мог
 * верно обрабатывать и валидировать. В особенности это касается тех шагов, где участвует несколько полей сразу.
 *
 * Утилита всегда возвращает новый объект.
 *
 * @param questionFields – Массив полей на текущем шаге (вопросе).
 * @param formValues – Текущие значения полей в форме.
 *
 * @returns Новый объект со значениями полей формы, включая текущий шаг.
 */
export var prepareFormStepValues = function prepareFormStepValues(questionFields, formValues) {
  return questionFields.reduce(function (values, field) {
    if (!values[field.name]) {
      values[field.name] = undefined;
    }
    return values;
  }, _objectSpread({}, formValues));
};